// External
import { getCookies } from "cookies-next";
import React, { useEffect, useState } from "react";
// Internal
import store, { withServerStore } from "store";
import {
  getAddressInfo,
  getBrandBannerData,
  getBrandList,
  getBrandVehicleData,
  getCategoryBannerData,
  getCategoryList,
  getCategoryVehicleData,
  getCmsList,
  getDynamicPageData,
  getDynamicPageList,
  getFeaturedList,
  getLocations,
  getMetaData,
  getVehicalDetailData,
  setAddressInfo,
  setBrandList,
  setCategoryList,
  setCmsList,
  setCurrentLocationId,
  setDynamicPageList,
  setLocations,
  updateFilterClickCount,
  updateShareClickCount,
} from "store/actions";
import {
  REDIRECT_STATUS,
  getLocationFromSlugUsingLocationArr,
  getLocationFromSlugUsingLocationArrOneSlug,
  getLocationIdUsingCityStateSlug,
  getRecentlyViewedListFromCookie,
  get_cookie,
  makeCityStateSlugUsingLocation,
  setCityStateSlugInCookie,
  setCurrentLocationIdInCookie,
  strToLowerCase,
} from "utils";

import { getBlogDetail } from "store/actions/blog";

import Error500 from "components/Error500";
import Layout from "components/layout";
import Home from "pages/home";
// import CookiesModal from "components/modals/cookiesModal";
/********************
  @purpose : Show data as per slug
  @Parameter : {}
  @Author : INIC
  ******************/
const Slug = ({
  currentPage,
  metaData,
  locations,
  brandList,
  categoryList,
  addressInfo,
  dynamicPageList,
  currentLocationId,
  features,
  data,
  headerDark,
  headerWhite,
  isShowAddressInfo,
  selectedLocationName,
  brandBannerInfo,
  brandVehiclesData,
  categoryBannerInfo,
  categoryVehiclesData,
  headerSticky,
  vehicalDetailData,
  cmsDetailData,
  cmsList,
  cmsDetails,
  blogDetails,
  cityStateSlug,
  cityNameForMeta,
  recentlyViewedVehicleArr,
}) => {
  const [isMobileApp, setIsMobileApp] = useState();

  /********************
  @purpose : Reset filter click count and share click count
  @Parameter : {}
  @Author : INIC
  ******************/
  store?.dispatch(updateFilterClickCount(0));
  store?.dispatch(updateShareClickCount(0));
  /********************
  @purpose : Set current location id in cookie
  @Parameter : {currentLocationId}
  @Author : INIC
  ******************/
  setCurrentLocationIdInCookie(currentLocationId);
  /********************
  @purpose : Set cityStateSlug in cookie
  @Parameter : {cityStateSlug}
  @Author : INIC
  ******************/
  setCityStateSlugInCookie(cityStateSlug);

  useEffect(() => {
    /********************
  @purpose : Set location data,brandList,
  categoryList,addressInfo,dynamicPageList,cmsList,currentLocationId in redux
  @Parameter : {locations}
  @Author : INIC
  ******************/
    store.dispatch(setLocations(locations));
    store.dispatch(setBrandList(brandList));
    store.dispatch(setCategoryList(categoryList));
    store.dispatch(setAddressInfo(addressInfo));
    store.dispatch(setDynamicPageList(dynamicPageList));
    store.dispatch(setCmsList(cmsList));
    store.dispatch(setCurrentLocationId(currentLocationId));
  }, [currentLocationId, cityStateSlug]);

  useEffect(() => {
    setIsMobileApp(get_cookie("is_mobile_app"));
  }, []);

  return (
    <>
      {currentPage !== "500" ? (
        <Layout
          page="home"
          metaData={metaData}
          locations={locations}
          brandList={brandList}
          categoryList={categoryList}
          addressInfo={addressInfo}
          dynamicPageList={dynamicPageList}
          currentLocationId={currentLocationId}
          headerDark={headerDark}
          headerWhite={headerWhite}
          isShowAddressInfo={isShowAddressInfo}
          selectedLocationName={selectedLocationName}
          headerSticky={headerSticky}
          currentPage={currentPage}
          cmsList={cmsList}
          brandBannerInfo={brandBannerInfo}
          categoryBannerInfo={categoryBannerInfo}
          vehicalDetailData={vehicalDetailData}
          cityNameForMeta={cityNameForMeta}
          homePageData={data?.page_details}
        >
          {/********************
        @purpose : Default page of react application
        @Author : INIC
        ********************/}
          <Home
            currentPage={currentPage}
            data={data}
            features={features}
            brandList={brandList}
            categoryList={categoryList}
            brandBannerInfo={brandBannerInfo}
            brandVehiclesData={brandVehiclesData}
            categoryBannerInfo={categoryBannerInfo}
            categoryVehiclesData={categoryVehiclesData}
            vehicalDetailData={vehicalDetailData}
            currentLocationId={currentLocationId}
            cmsDetailData={cmsDetailData}
            cmsDetails={cmsDetails}
            blogDetails={blogDetails}
          />

          {/* {isMobileApp !== "yes" && <CookiesModal />} */}
        </Layout>
      ) : (
        <Error500 />
      )}
    </>
  );
};
export default Slug;

/********************
  @purpose : server side rendering
  @Parameter : {}
  @Author : INIC
  ******************/
export const getServerSideProps = withServerStore(async ({ query, req, res, resolvedUrl, store }) => {
  /*
  res.setHeader(
    "Cache-Control",
    "public, s-maxage=0, stale-while-revalidate=1"
  );*/

  // Check if the URL has a trailing slash

  let slug = query.slug;
  const tempCityStateSlug = getCookies({ req, res }).cityStateSlug;
  let authorizationToken = "";
  if (getCookies({ req, res })?.token) {
    authorizationToken = getCookies({ req, res }).token;
  }

  const recentlyViewedVehicleArr = getRecentlyViewedListFromCookie(
    slug?.[0],
    req,
    res
  ); // Adjust this function to work on the server if needed
  let id = "";
  let metaData = "";
  let locations = "";
  let brandList = "";
  let categoryList = "";
  let addressInfo = "";
  let dynamicPageList = "";
  let features = "";
  let data = "";
  let currentPage = "404";
  let headerDark = false;
  let headerWhite = false
  let isShowAddressInfo = true;
  let selectedLocationName = "ca";
  let loadHomeData = false;
  let loadDynamicData = false;
  let slug1 = "";
  let slug2 = "";
  let slug3 = "";
  let brandBannerInfo = "";
  let brandVehiclesData = "";
  let categoryBannerInfo = "";
  let categoryVehiclesData = "";
  let headerSticky = false;
  let vehicalDetailData = "";
  let cmsDetailData = "";
  let cmsList = "";
  let blogDetails = "";
  let cmsDetails = "";
  let cityStateSlug = "";
  let cityNameForMeta = "Los Angeles";
  let list = "";
  let cmsServingProposeSlug = "";


  // // Map the `slug_id` from the recently viewed vehicles
  const slugIdsQuery = recentlyViewedVehicleArr
    .map((slugId, index) => `slugIds[${index}]=${slugId}`)
    .join("&");
  // get locations list
  list = await store.dispatch(getLocations(true));

  if (list && list.statusCode != "503") {
    locations = list?.data;

    if (locations && locations.length > 0) {
      // cms or serving or blog

      if (slug.length === 1) {
        if (tempCityStateSlug) {
          id = getLocationIdUsingCityStateSlug(locations, tempCityStateSlug);
        } else {
          id = locations["0"]["id"];
          cityStateSlug = makeCityStateSlugUsingLocation(locations["0"]);
        }
        slug2 = slug[0];
        // Check page is serving or cms or blog
        data = await store.dispatch(
          getDynamicPageData(id, slug2, 0, authorizationToken)
        );

        if (data.length === 0) {
          // call cms detail api
          headerDark = false;
          headerWhite = true
          let data = await store.dispatch(getBlogDetail(slug[0]));

          if (data.type === "CMS") {
            cmsDetails = data;
            metaData = {
              title: data.seo_title,
              description: data.seo_description,
              keywords: data.seo_keywords,
            };
            currentPage = "cms";
          } else if (data.type === "Blog") {
            blogDetails = data;
            metaData = {
              title: data.seo_title,
              description: data.seo_description,
              keywords: data.seo_keywords,
            };
            currentPage = "blogdetail";
          } else {
            headerDark = false;
            headerWhite = false;
            // invalid url
            id = "";
          }
        } else {
          currentPage = "dynamic";
          loadDynamicData = true;
          cmsServingProposeSlug = slug2;
        }
      }

      // home or dynamic page
      else if (slug.length === 2) {
        currentPage = "home";
        const location = getLocationFromSlugUsingLocationArr(
          locations,
          slug[0],
          slug[1]
        );

        if (location) {
          cityStateSlug = makeCityStateSlugUsingLocation(location);
          id = location?.id;
          selectedLocationName = strToLowerCase(location?.state_short_name);
          loadHomeData = true;
        } else {
          if (tempCityStateSlug) {
            id = getLocationIdUsingCityStateSlug(locations, tempCityStateSlug);
          } else {
            const location1 = getLocationFromSlugUsingLocationArrOneSlug(
              locations,
              slug[0]
            );

            if (location1) {
              id = location1?.id;
              cityStateSlug = makeCityStateSlugUsingLocation(location1);
            }
          }
          currentPage = "dynamic";
          loadDynamicData = true;
          slug2 = slug[1];
          cmsServingProposeSlug = slug2;
          data = await store.dispatch(
            getDynamicPageData(id, slug2, 0, authorizationToken, slugIdsQuery)
          );
          // invalid url
          if (data.length === 0) {
            id = "";
          }
        }
      }

      // category or brand or serving page
      else if (slug.length === 3) {
        const location = getLocationFromSlugUsingLocationArr(
          locations,
          slug[0],
          slug[1]
        );

        if (location) {
          cityStateSlug = makeCityStateSlugUsingLocation(location);
          id = location?.id;
          selectedLocationName = strToLowerCase(location?.state_short_name);
          slug3 = slug[2];

          // Check page is serving
          data = await store.dispatch(
            getDynamicPageData(id, slug3, 0, authorizationToken)
          );
          if (data.length === 0) {
            // get brand data and vehicle data
            brandBannerInfo = await store.dispatch(
              getBrandBannerData(id, slug3)
            );
            brandBannerInfo = Object.assign({}, brandBannerInfo);
            if (
              brandBannerInfo &&
              Object.keys(brandBannerInfo).length === 0 &&
              Object.getPrototypeOf(brandBannerInfo) === Object.prototype
            ) {
              // category related data
              categoryBannerInfo = await store.dispatch(
                getCategoryBannerData(id, slug3)
              );
              categoryBannerInfo = Object.assign({}, categoryBannerInfo);

              if (
                categoryBannerInfo &&
                Object.keys(categoryBannerInfo).length === 0 &&
                Object.getPrototypeOf(categoryBannerInfo) === Object.prototype
              ) {
                // invalid url
                id = "";
              } else {
                currentPage = "category";
                categoryVehiclesData = await store.dispatch(
                  getCategoryVehicleData(id, slug3, authorizationToken)
                );
                metaData = await store.dispatch(
                  getMetaData(id, slug3, "category_slug")
                );
              }
            } else {
              // brand related data
              currentPage = "brand";
              brandVehiclesData = await store.dispatch(
                getBrandVehicleData(id, slug3, authorizationToken)
              );
              metaData = await store.dispatch(
                getMetaData(id, slug3, "brand_slug")
              );
            }
          } else {
            currentPage = "dynamic";
            loadDynamicData = true;
            cmsServingProposeSlug = slug3;
          }
        }
      }

      // vehical detail page
      else if (slug.length === 6) {
        headerSticky = true;

        const location = getLocationFromSlugUsingLocationArr(
          locations,
          slug[0],
          slug[1]
        );

        if (location) {
          cityStateSlug = makeCityStateSlugUsingLocation(location);
          id = location?.id;
          cityNameForMeta = location?.city_name;

          // get vehicle detail data
          vehicalDetailData = await store.dispatch(
            getVehicalDetailData(id, slug[4], slug[2], slug[3])
          );

          vehicalDetailData = Object.assign({}, vehicalDetailData);

          if (vehicalDetailData && vehicalDetailData?.redirect_url) {
            // invalid url
            res.writeHead(REDIRECT_STATUS, {
              Location: vehicalDetailData?.redirect_url,
            });
            res.end();
            return { props: {} };
          } else {
            currentPage = "vehicle";
            metaData = await store.dispatch(
              getMetaData(id, slug["4"], "vehicle_slug")
            );
            isShowAddressInfo = false;
          }
        }
      } else {
        // invalid url
        id = "";
      }

      if (id) {
        // get address info using location id
        addressInfo = await store.dispatch(getAddressInfo(id));

        // get featured list  using location id
        features = await store.dispatch(getFeaturedList());

        // get home page data
        if (loadHomeData) {
          // get meta data of home page
          metaData = await store.dispatch(getMetaData(id, "home", "pageName"));
          data = await store.dispatch(
            getDynamicPageData(id, "home", 0, authorizationToken, slugIdsQuery)
          );
        }

        // get dynamic page data
        if (loadDynamicData) {
          // get meta data of home page
          metaData = await store.dispatch(
            getMetaData(id, cmsServingProposeSlug, "dynamic_page_slug")
          );
        }
      } else {
        id = locations["0"]["id"];
        currentPage = "404";
        headerDark = true;
        isShowAddressInfo = false;
        res.writeHead(REDIRECT_STATUS, { Location: "/" });
        res.end();
      }

      // get brand list using location id
      brandList = await store.dispatch(getBrandList(id));

      // get category list using location id
      categoryList = await store.dispatch(getCategoryList(id));

      // get dynamic page using location id
      dynamicPageList = await store.dispatch(getDynamicPageList(id));

      // get cms list
      cmsList = await store.dispatch(getCmsList());
    } else {
      currentPage = "500";
    }
  } else {
    if (typeof list == "undefined") {
      currentPage = "500";
    } else {
      return {
        redirect: {
          destination: "/maintenance",
        },
      };
    }
  }

  if (resolvedUrl.endsWith("/")) {
    res.writeHead(REDIRECT_STATUS, {
      Location: resolvedUrl.slice(0, -1),
    });
    res.end();
    return { props: {} };
  }

  return {
    props: {
      recentlyViewedVehicleArr,
      currentPage: currentPage,
      headerDark: headerDark,
      headerWhite: headerWhite,
      metaData: metaData,
      locations: locations ?? "",
      brandList: brandList,
      categoryList: categoryList,
      addressInfo: addressInfo,
      dynamicPageList: dynamicPageList,
      currentLocationId: id,
      features: features,
      data: data,
      isShowAddressInfo: isShowAddressInfo,
      selectedLocationName: selectedLocationName,
      brandBannerInfo: brandBannerInfo,
      brandVehiclesData: brandVehiclesData,
      categoryBannerInfo: categoryBannerInfo,
      categoryVehiclesData: categoryVehiclesData,
      headerSticky: headerSticky,
      vehicalDetailData: vehicalDetailData,
      cmsDetailData: cmsDetailData,
      cmsList: cmsList,
      cmsDetails: cmsDetails,
      blogDetails: blogDetails,
      cityStateSlug: cityStateSlug ? cityStateSlug : tempCityStateSlug,
      cityNameForMeta: cityNameForMeta,
    },
  };
});
